import {
  WorkflowTransitionInfoFragment,
  WorkflowTransitionInfoQuery,
  WorkflowTransitionInfoQueryVariables,
  useWorkflowTransitionInfoQuery,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

export const useWorkflowTransitionInfo = withStandardGetHook<
  WorkflowTransitionInfoQuery,
  WorkflowTransitionInfoFragment,
  'workflowVersion',
  WorkflowTransitionInfoQueryVariables
>(useWorkflowTransitionInfoQuery, 'workflowVersion', {
  fetchPolicy: 'cache-first',
});
